import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import user from './modules/user.js';
import admin from './modules/admin.js';
import polygon from './modules/polygon.js';

export default createStore({
  modules: { user, admin, polygon },
  plugins: [
    createPersistedState({
    })
  ],
});
